import { Component, OnInit } from '@angular/core';
import { BoKycLvl2IdentityTypeSelectedV2Component } from '../../bo-kyc-lvl2-identity-type-selected-v2.component';
import { NibssVerificationService } from '@mpt-fo/common/core/services/nibss-verification.service';
import { OnboardingV2Service } from '@mpt-fo/common/core/services/onboarding-v2.service';
import { ModalService } from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import { ScreenManagerService } from "@mpt-fo/common/core/services/screen-manager.service";
import { DataLayerService } from '@mpt-fo/common/core/services/data-layer-service.service';
import { LocalStorageService } from '@mpt-fo/common/core/services/local-storage.service';

@Component({
	selector: 'app-bo-kyc-lvl2-identity-type-selected-mobile-v2',
	templateUrl: './bo-kyc-lvl2-identity-type-selected-mobile-v2.component.html',
	styleUrls: ['./bo-kyc-lvl2-identity-type-selected-mobile-v2.component.scss'],
})
export class BoKycLvl2IdentityTypeSelectedMobileV2Component extends BoKycLvl2IdentityTypeSelectedV2Component implements OnInit {
	constructor(onboardingService: OnboardingV2Service, modalService: ModalService, nibssService: NibssVerificationService, screenManagerService: ScreenManagerService,
		public dataLayerHelper: DataLayerService,
		public localStorage: LocalStorageService,
	) {
		super(onboardingService, modalService, nibssService, screenManagerService, dataLayerHelper, localStorage);
	}

	ngOnInit(): void {
		this.initialize().then(() => {
			this.loading = false;
		});
	}
}
